module.exports = __webpack_public_path__ + "4367a4ccdcb62db86cd316588fc9ee09.png";